import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/img/pagato.svg'
import _imports_1 from '@/img/in_attesa.svg'
import _imports_2 from '@/img/saldo.svg'


const _hoisted_1 = { class: "box d-flex flex-column justify-content-between" }
const _hoisted_2 = { class: "boxTitle d-flex justify-content-between" }
const _hoisted_3 = { class: "portafoglioLower mt-3" }
const _hoisted_4 = { class: "portafoglioItem" }
const _hoisted_5 = { class: "itemLabel" }
const _hoisted_6 = { class: "grosso" }
const _hoisted_7 = { class: "portafoglioItem" }
const _hoisted_8 = { class: "itemLabel" }
const _hoisted_9 = { class: "grosso" }
const _hoisted_10 = { class: "portafoglioItem" }
const _hoisted_11 = { class: "itemLabel" }
const _hoisted_12 = { class: "grosso" }
const _hoisted_13 = { class: "text-end" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "text-end"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_doughnut_chart = _resolveComponent("doughnut-chart")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Portafoglio",
          text: "Portafoglio"
        })
      ])
    ]),
    (_ctx.portafoglio)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_doughnut_chart, {
            class: "max-canvas-400 text-saldo",
            value: [_ctx.portafoglio.withdrawed, _ctx.portafoglio.waiting, _ctx.portafoglio.balance],
            label: ['Prelevato', 'In attesa', ' Saldo'],
            color: ['#48dbab', '#f27a9a', '#c58700'],
            centerLabel: "Saldo",
            centerNumber: _ctx.portafoglio.balance
          }, null, 8, ["value", "centerNumber"]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "icon pagato" }, [
                _createElementVNode("img", { src: _imports_0 })
              ], -1)),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Pagato",
                  text: "Pagato"
                }),
                _cache[2] || (_cache[2] = _createTextVNode(" € "))
              ]),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.portafoglio.withdrawed), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "icon inAttesa" }, [
                _createElementVNode("img", { src: _imports_1 })
              ], -1)),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_localized_text, {
                  localizedKey: "In attesa",
                  text: "In attesa"
                }),
                _cache[4] || (_cache[4] = _createTextVNode(" € "))
              ]),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.portafoglio.waiting), 1),
              _createVNode(_component_router_link, {
                to: '/dashboard/commissions/' + _ctx.user.identifier
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Vedi",
                    text: "Vedi"
                  })
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "icon saldo" }, [
                _createElementVNode("img", { src: _imports_2 })
              ], -1)),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Saldo",
                  text: "Saldo"
                }),
                _cache[6] || (_cache[6] = _createTextVNode(" € "))
              ]),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$filters.currency(_ctx.portafoglio.total, 0)), 1),
              _createVNode(_component_router_link, {
                to: '/dashboard/walletTransactions/' + _ctx.user.identifier
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Vedi",
                    text: "Vedi"
                  })
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("hr", null, null, -1)),
          _createElementVNode("div", _hoisted_13, [
            (_ctx.canRequestPaymentVm)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (!_ctx.canRequestPaymentVm.canRequest)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Le richieste di pagamento vanno inserite <b>dal giorno {{dayFrom}} al giorno {{dayTo}} del mese </b>",
                          text: "Le richieste di pagamento vanno inserite <b>dal giorno {{dayFrom}} al giorno {{dayTo}} del mese </b>",
                          object: { dayFrom: _ctx.canRequestPaymentVm.pagamentoRequestConfig.dayFrom, dayTo: _ctx.canRequestPaymentVm.pagamentoRequestConfig.dayTo }
                        }, null, 8, ["object"])
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (!_ctx.pendingRequest)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn btn-primary",
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.richiediPagamentoModal && _ctx.richiediPagamentoModal(...args)))
                            }, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "Richiedi pagamento",
                                text: "Richiedi pagamento"
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createElementVNode("div", null, [
                                _createElementVNode("b", null, [
                                  _createVNode(_component_localized_text, {
                                    localizedKey: "Richiesta di pagamento inserita:",
                                    text: "Richiesta di pagamento inserita:"
                                  })
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _createVNode(_component_localized_text, {
                                  localizedKey: "Data ricevuta:",
                                  text: "Data ricevuta:"
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.$filters.date(_ctx.pendingRequest.date)), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _createVNode(_component_localized_text, {
                                  localizedKey: "Importo:",
                                  text: "Importo:"
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.$filters.currency(_ctx.pendingRequest.amount)) + " € ", 1)
                              ]),
                              (_ctx.pendingRequest.allegato)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _createElementVNode("a", {
                                      href: _ctx.pendingRequest.allegato.publicUrl,
                                      target: "_blank"
                                    }, [
                                      _createVNode(_component_localized_text, {
                                        localizedKey: "Vedi allegato",
                                        text: "Vedi allegato"
                                      })
                                    ], 8, _hoisted_17)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", null, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-danger mt-2",
                                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.annullaRichiestaPagamento && _ctx.annullaRichiestaPagamento(...args)))
                                }, [
                                  _createVNode(_component_localized_text, {
                                    localizedKey: "Annulla richiesta di pagamento",
                                    text: "Annulla richiesta di pagamento"
                                  })
                                ])
                              ])
                            ]))
                      ], 64))
                ], 64))
              : _createCommentVNode("", true)
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}